// src/components/ImplantToggle.js
import React from 'react';
import { isImplantMode, setImplantMode } from '../utils/implantFilter';
import useImplantMode from '../utils/useImplantMode';
import './ImplantToggle.css';

const ImplantToggle = () => {
  const on = useImplantMode();

  // No page reload: setImplantMode() notifies the layout, which re-mounts the
  // current page so it loads its data again with / without ?group=implant.
  const toggle = () => setImplantMode(!isImplantMode());

  return (
    <button
      type="button"
      className={`implant-toggle ${on ? 'active' : ''}`}
      onClick={toggle}
      title={on ? 'Implant filter ON - click to show all data' : ''}
    >
      <span className="implant-toggle-dot" />
      Implant{on ? ': ON' : ''}
    </button>
  );
};

export default ImplantToggle;